import createConverter from './lib/create_converter';
import Conversation from 'models/conversation';

export default createConverter(Conversation);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/conversation_converter.js